<template>
<el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix" style="position:relative">
    <el-breadcrumb>
      <el-breadcrumb-item>基础设置</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="text item">
    <el-form ref="form" :model="form" label-width="140px">
      <p class="dividerLine">系统设置</p>
      <el-form-item label="pdf备注">
        <quill-editor ref="text" v-model="form.content" class="myQuillEditor" :options="editorOption" />
      </el-form-item>
      <el-form-item label="状态">
        <el-switch  v-model="form.status"></el-switch>
      </el-form-item>
      <el-form-item label="关闭原因" v-show="!form.status">
        <el-input v-model="form.closeMessage" type="textarea" rows="2" placeholder="请输入.."></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button @click="saveConfig" type="primary">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</el-card>
</template>
<script>
import { quillEditor } from 'vue-quill-editor'
import settingFunction from "@/api/setting"
export default {
  data() {
    return {
      editorOption: {} ,
      content:'',
      form:{
        status:true,
        closeMessage:'',
        content:'',
        vcode:sessionStorage.getItem('token'),
      }
    }
  },
  components: {
    quillEditor
  },
  methods:{
    saveConfig(){
      settingFunction.saveConfig(this.form,this).then((res) => {
      })
    },
    getConfig(){
      settingFunction.getConfig({vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.form.status = res.status ==1 ? true : false
        this.form.closeMessage = res.closeMessage
        this.form.content = res.content
      })
    }
  },
  mounted () {
    this.getConfig()
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/set/set.vue